export const secondary20 = '#333333'
export const secondary40 = '#666666'
export const secondary60 = '#999999'
export const secondary70 = '#B3B3B3'
export const secondary80 = '#CCCCCC'
export const secondary90 = '#E6E6E6'
export const secondary95 = '#F1F1F1'
export const secondary98 = '#F8F8F8'

export const primary35 = '#047BAE'
export const primary40 = '#0A8BC2'
export const primary60 = '#52B5E0'
export const primary80 = '#9EDEFA'
export const primary90 = '#CCF0FF'
export const primary95 = '#E5F7FF'
export const primary100 = '#EDFBFF'
export const primaryLightest = '#F5FDFF'

export const info = '#906AAF'
export const alert = '#EE7784'
export const warning = '#FFB366'
export const success = '#A7BF4E'
export const resolved = '#4FC1AD'
export const mint = '#EDFCF7'

export const infoBg = '#F4E7FDCC'
export const alertBg = '#FCE8EBCC'
export const warningBg = '#FDF6E7CC'
export const successBg = '#ECF1DACC'

export const infoText = '#4F3663'
export const alertText = '#B51728'
export const warningText = '#BF670D'
export const successText = '#617029'

export const info55 = '#906AAF'
export const info70 = '#B791D4'
export const info80 = '#CFB5E3'
export const infoGray = '#ECDCEB'
export const alert40 = '#B51728'
export const alert65 = '#EB606F'
export const alert70 = '#EE7784'
export const alert75 = '#F18E98'
export const alert85 = '#F7BBC1'
export const warning40 = '#BF670D'
export const warning50 = '#EE8111'
export const warning60 = '#FF9A33'
export const warning70 = '#FFB366'
export const warning80 = '#FFCD99'
export const success30 = '#617029'
export const success45 = '#92A93D'
export const success53 = '#A7BF4E'
export const success63 = '#BCD071'
export const success73 = '#CDDA9A'
export const success90 = '#E8ECD7'
export const paused47 = '#D7A618'
export const paused55 = '#E8B931'
export const paused65 = '#EDC85F'
export const paused80 = '#F5E0A3'
export const paused90 = '#EBE695'
export const pausedGray = '#F1E8CB'

export const globalGray = '#BFD6F2'

export const gray40 = '#666666'

export const highlight = '#F7EF98'
export const hover = primary90

export const bgAlertActive = '#EB606F'
export const bgAlertDefaultNotification = '#F9E6E8'
export const bgAlertFocus = '#F18E98'
export const bgAlertHover = '#EE7784'
export const bgInfoDefaultNotification = '#F6ECFD'
export const bgInfoHover = '#906AAF'
export const bgPrimaryActive = '#047BAE'
export const bgPrimaryActiveTab = '#EDFBFF'
export const bgPrimaryFocus = '#52B5E0'
export const bgPrimaryHover = '#CCF0FF'
export const bgPrimaryHoverButton = '#0A8BC2'
export const bgPrimarySelect = '#9EDEFA'
export const bgSecondaryActive = '#666666'
export const bgSecondaryActiveTooltip = '#333333'
export const bgSecondaryDefault = '#FFFFFF'
export const bgSecondaryDefaultExpand = '#E6E6E6'
export const bgSecondaryDefaultSubmenu = '#F8F8F8'
export const bgSecondaryDefaultSubsection = '#E6E6E6'
export const bgSecondaryHover = '#999999'
export const bgSecondaryStripe = '#F1F1F1'
export const bgSecondaryStripeExpand = '#CCCCCC'
export const bgStatus1 = '#E6ACAC'
export const bgStatus2 = '#F7BBC1'
export const bgStatus3 = '#F5A6C3'
export const bgStatus4 = '#FFCEC7'
export const bgStatus5 = '#C0E7D0'
export const bgStatus6 = '#C5E79D'
export const bgStatus7 = '#CDDA9A'
export const bgStatus8 = '#E6F797'
export const bgStatus9 = '#EBE695'
export const bgStatus10 = '#F5E0A3'
export const bgStatus11 = '#F7EF98'
export const bgStatus12 = '#BFD6F2'
export const bgStatus13 = '#C0C8E7'
export const bgStatus14 = '#CFB5E3'
export const bgSuccessActive = '#92A93D'
export const bgSuccessFocus = '#BCD071'
export const bgSuccessHover = '#A7BF4E'
export const bgWarningDefaultNotification = '#FBF3DA'
export const bgWarningHover = '#FFB366'
export const borderInfoDefault = '#906AAF'
export const borderLabelDefault = '#EE7784'
export const borderPrimaryDefault = '#0A8BC2'
export const borderSecondaryDefault = '#B3B3B3'
export const borderSecondaryDefaultDivider = '#CCCCCC'
export const borderSecondaryDefaultDividerList = '#F1F1F1'
export const borderSuccessDefault = '#A7BF4E'
export const borderWarningDefault = '#FFB366'
export const contentPrimaryActive = '#047BAE'
export const contentPrimaryHover = '#0A8BC2'
export const contentSecondaryActive = '#333333'
export const contentSecondaryDefault = '#666666'
export const contentSecondaryInactive = '#B3B3B3'
export const contentSecondaryInvert = '#FFFFFF'
export const contentSecondaryInvertTitle = '#E6E6E6'
export const contentSecondaryTitle = '#999999'
export const contentSuccessActive = '#617029'
